export class UnsupportedAssetError extends Error {
    name = 'UnsupportedAssetError';
    constructor(assetName) {
        super(`Asset "${assetName}" is not supported`);
    }
}
export class UnknownWalletAccountError extends Error {
    name = 'UnknownWalletAccountError';
    constructor(walletAccount) {
        super(`WalletAccount "${walletAccount}" not found`);
    }
}
export class UnsupportedAssetSourceError extends Error {
    name = 'UnsupportedAssetSourceError';
    constructor({ assetName, walletAccount }) {
        super(`Asset source "${walletAccount}:${assetName}" is not supported`);
    }
}
